import { Component, Input, OnInit } from '@angular/core';

/**
 * Component class for bubble timeline
 */
@Component({
    selector: 'rms-bubble-timeline',
    templateUrl: './bubble-timeline.component.html',
    styleUrls: ['./bubble-timeline.component.scss'],
    standalone: false
})
export class BubbleTimelineComponent implements OnInit {

  @Input() stages: Array<string>;
  @Input() currentStage: number;
  @Input() currentStageOnly = false;
  @Input() rejected: boolean;
  @Input() vertical = false;
  @Input() height = 0;

  public stagesToRender = [];
  public currentStageToRender = 0;

  constructor() {
  }

  ngOnInit() {
    this.stagesToRender = this.currentStageOnly ? [this.stages[this.currentStage]] : this.stages;
    this.currentStageToRender = this.currentStageOnly ? 0 : this.currentStage;
    this.height = Math.max(40 * this.stages.length, this.height);
  }

  public getProgressWidth(): string {
    return ((this.currentStageToRender / (this.stagesToRender.length - 1)) * 100) + '%';
  }

  public getIcon(index: number): string {
    if (index === this.currentStageToRender && this.rejected) {
      return 'cancel';
    } else if (index === this.currentStageToRender && this.currentStage === 2) {
      return 'circle';
    } else if (index <= this.currentStageToRender) {
      return 'check';
    } else {
      return null;
    }
  }
}
